module.exports = {
	"auctioneer": {
		"notOngoing": "Cet encan n'est pas en cours. Il doit être en cours pour accéder à l'interface encanteur."
	},
	"cannotEdit": "Vous ne pouvez pas modifier un encan en cours.",
	"cannotEditLong": "S'il vous plaît, notez que vous ne pouvez pas modifier un encan alors qu'il est en cours.",
	"cannotPublish": "Vous ne pouvez pas publier cet encan avant d'avoir ajouté au moins un lot dans la liste.",
	"linkAuctioneer": "Interface encanteur",
	"linkAuctionControl": "Contrôle en temps réel des encans",
	"linkAuctionHistory": "Historique des événements",
	"linkAuctionReport": "Rapport d'encan",
	"linkMonitor": "Affichage public",
	"linkPicture": "Photo de l'encan",
	"linkSettings": "Paramètres de l'encan",
	"name": "Nom de l'encan",
	"scheduled": "Date prévue / Heure",
	"type": "Type",
	"typeLive": "Encan en temps réel",
	"typeOnline": "Encan en ligne seulement",
	"publish": {
		"publish": "Publier",
		"confirm": "Êtes-vous certain de vouloir publier cet encan? $t(general::cannotUndo)",
		"success": "Votre encan a été publié avec succès!"
	},
	"cancel": {
		"cancel": "Annuler l'encan",
		"confirm": "Êtes-vous certain de vouloir annuler cet encan? Vous allez perdre toutes les enchères effectuées jusqu'à présent. $t(general::cannotUndo)",
		"success": "Votre encan a été annulé avec succès! Les participants vont en être informés."
	},
	"auctionControl": {
		"header": "Contrôler l'encan en temps réel",
		"auctionCancelled": "L'encan a été annulé, vous ne pouvez pas démarrer.",
		"auctionLive": "L'encan est en cours!",
		"auctionOver": "L'encan est terminé. Voulez-vous consulter l'historique des événements?",
		"auctionReady": "L'encan n'a pas encore démarré.",
		"auctionUnpublished": "L'encan n'a pas encore démarré. Pour démarrer l'encan, vous devez d'abord le publier.",
		"startButton": "DÉMARRER L'ENCAN"
	},
	"auctionCreate": {
		"header": "Créer un nouvel encan",
		"createBtn": "Créer un encan"
	},
	"auctionHistory": {
		"header": "Historique des événements"
	},
	"auctionIncrements": {
		"header": "Augmentation des offres"
	},
	"auctionNumberOfLots": "Vous n'avez pas créé de lot pour votre encan. Toutefois, comme vous avez indiqué que l'encan ne doit pas permettre les pré-offres, vous pouvez simplement indiquer le nombre de lots qu'il y aura pour cet encan et ensuite le publier.",
	"auctionList": {
		"header": "Liste d'encan",
		"addAFirstOne": "Vous pouvez ajouter un premier encan en cliquant ici",
		"addLotBtn": "Ajouter un lot",
		"auctionsList": "Liste d'encan",
		"createAuctionBtn": "Créer un encan",
		"empty": "La liste d'encan est vide!",
		"manageAuctionBtn": "Gérer l'encan",
		"noLotsForNow": "Cet encan n'a pas de lot pour l'instant.",
		"rankChanged": "Vous avez changé l'ordre de classement de cet encan. Le lot occupant un nouveau rang est surligné en bleu et le lot que vous avez déplacé est surligné en jaune. Décidez si vous voulez conserver ce changement ou l'annuler.",
		"status": "Statut"
	},
	"auctionLiveBidding": {
		"description": "Cet encan aura un événement de vente en temps réel",
		"name": "Temps réel"
	},
	"auctionPermissions": {
		"header": "Autorisations et limites des offres",
		"allowed": "Autorisé",
		"bidInLiveAuction": "Offre en temps réel",
		"bidLimit": "Limite d'offre",
		"insertListPermissions": "Insérer une liste d'utilisateurs avec autorisations spécifiques",
		"manageUsersList": "Gérer les listes d'utilisateurs",
		"notAllowed": "Non autorisé",
		"noUserList": "Vous n'avez pas d'autre liste d'utilisateurs que vous pouvez ajouter.",
		"previewCatalog": "Aperçu du catalogue",
		"purchaseLimit": "Limite d'achat total",
		"selectUserList": "Sélectionnez une liste d'utilisateurs pour laquelle vous désirez ajouter des autorisations",
		"specificAmount": "Montant spécifique",
		"unlimited": "Illimité",
		"viewLiveAuction": "Voir l'encan en temps réel"
	},
	"auctionPicture": {
		"header": "Photo de l'encan",
		"auctionPictureLabel": "Photo pour miniature"
	},
	"auctionReport": {
		"header": "Rapport d'encan"
	},
	"auctionSettings": {
		"header": "Paramètres du profil d'encan",
		"updateBtn": "Mise à jour des informations"
	},
	"auctionTerms": "Utilisez ce champ afin de décrire les règles de conduite, politiques et conditions de participation à votre encan.",
	"auctionUserList": {
		"addEmail": "Ajouter un courriel d'invitation",
		"addToken": "Ajouter un jeton",
		"allUnverified": "Tous les acheteurs __brand__ non vérifiés",
		"allVerified": "Tous les acheteurs __brand__ vérifiés",
		"cancelInvite": "Annuler l'invitation",
		"cancelToken": "Annuler le jeton",
		"create": "Créer une liste",
		"createList": "Créer une nouvelle liste",
		"defaultUserList": "Liste d'utilisateurs par défaut",
		"editList": "Modifier la liste",
		"emailInvites": "Envoyer des invitations",
		"header": "Liste d'utilisateurs",
		"explain": "Vous pouvez ajouter n'importe quelle adresse courriel à la liste d'utilisateurs, ils vont recevoir un avis s'ils n'ont pas de compte. S'ils ont déjà un compte __brand__, ils vont tout de même recevoir un avis, mais ils seront automatiquement ajoutés aux membres de la liste d'utilisateurs.",
		"inviteEmail": "Ajouter un courriel d'invitation pour cette liste.",
		"inviteToken": "Ajouter un jeton pour cette liste.",
		"label": "Envoyer une invitation à l'adresse électronique suivante:",
		"labelToken": "Utilisez le jeton généré suivant ou entrez le vôtre:",
		"members": "Membres",
		"memberUsers": "Utilisateurs membres",
		"modalCreateListLabel": "Entrez un nom pour identifier cette liste d'utilisateurs.",
		"modalCreateListPlaceholder": "Nom de la liste",
		"modalRemoveListLabel": "Êtes-vous certain de vouloir supprimer cette liste?",
		"noEmail": "Aucun courriel d'invitation dans cette liste.",
		"noLists": "Vous n'avez pas de listes d'utilisateurs.",
		"noMembers": "Aucun membre dans cette liste.",
		"noToken": "Aucun jeton invité dans cette liste.",
		"pending": "Invitations en attente",
		"removeEmail": "Retirer le courriel d'invitation de la liste",
		"removeFromList": "Retirer l'utilisateur de la liste",
		"removeList": "Retirer la liste",
		"removeUser": "Retirer l'utilisateur",
		"send": "Envoyer l'invitation",
		"token": "Jeton",
		"tokenInvites": "Jeton d'invitation",
		"userLists": "Listes d'utilisateurs"
	},
	"bidReport": {
		"header": "Rapport des enchères reçues",
		"highestBid": "Enchère en tête",
		"receivedBids": "Enchères reçues"
	},
	"userListRequests": {
		"menuName": "Requêtes d'adhésion ",
		"name": "Requêtes d'adhésion à une liste d'utilisateurs",
		"none": "Il n'y a présentement aucune requête d'adhésion à une liste utilisateur.",
		"userDenied": "La demande de l'utilisateur a été refusée.",
		"userGranted": "L'utilisateur à été ajouté à <userListName />."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/oa-auction.json5
// module id = 1995
// module chunks = 6